import { render, staticRenderFns } from "./MeetingRegisterMandateName.vue?vue&type=template&id=68d4475e&"
import script from "./MeetingRegisterMandateName.vue?vue&type=script&lang=js&"
export * from "./MeetingRegisterMandateName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports